import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=147e6b88&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
import style0 from "./Footer.vue?vue&type=style&index=0&id=147e6b88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147e6b88",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PublicLogo: require('/opt/atlassian/pipelines/agent/build/components/public/Logo.vue').default,PublicContact: require('/opt/atlassian/pipelines/agent/build/components/public/Contact.vue').default})
